import styled, { css } from 'styled-components';
import { switchProp, prop } from 'styled-tools';
import { Radio } from './radio';
export const RadioGroup = styled(Radio.Group)`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  .ant-radio-button-wrapper {
    ${switchProp(prop('size', 'middle'), {
    middle: css`
        height: var(--height-base);
        line-height: calc(var(--height-base) - 2px);
        padding: 0 var(--spacing-03);
      `
})};

    > span {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
    }

    svg {
      margin-right: var(--spacing-03);
    }
  }
`;
